import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Footer from "./Footer.js";
import { Landing } from "./Landing";
import Login from "./Login.js";
import Nav from "./Nav.js";
import NotFound from "./NotFound.js";
import Profile from "./Profile.js";
import Register from "./Register.js";
import Rent from "./Rent.js";

function App(props) {
  const [userUid, setUid] = useState(null);
  let updateUid = (newUid) => {
    setUid(newUid);
  };
  return (
    <div>
      <Nav userUid={userUid} />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/profile/:uid" element={<Profile uid={userUid} />} />
        <Route path="/rent/:uid" element={<Rent />} />
        <Route
          path="/login"
          element={<Login uid={userUid} callback={updateUid} />}
        />
        <Route path="/register" element={<Register callback={updateUid} />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
